import { CookSubscriptionCheckInConfigurationInterface } from "../interfaces/CookSubscriptionCheckInConfigurationInterface/CookSubscriptionCheckInConfigurationInterface";
import { CreateCookSubscriptionCheckInConfigurationInterface } from "../interfaces/CookSubscriptionCheckInConfigurationInterface/CreateCookSubscriptionCheckInConfigurationInterface";
import BaseService from "./BaseService";

export class CookSubscriptionCheckInConfigurationService extends BaseService<CookSubscriptionCheckInConfigurationInterface, CreateCookSubscriptionCheckInConfigurationInterface>{ 
    constructor(){
        let url: string = '/cook-subscription-checkin-configuration/admin'
        super(url)
    }
}